<app-protected-content [requiredRoles]="requiredRoles" [requireApprovedOrganization]="true">
<div class="container" *transloco="let t; prefix: 'organization.member.edit'">
  <htx-button variant="tertiary" icon="arrow_back" (click)="backToDetail()">{{ 'button.back' | transloco }}</htx-button>

  <div class="panel">
    <div class="edit-header">
      <div class="header-title-section">
        <h1 class="header-title">{{ t('header') }}</h1>
        <p class="header-subtitle">{{ t('subtitle') }}</p>
      </div>
      <htx-button
        variant="tertiary"
        icon="save"
        (click)="save()"
        [disabled]="form.invalid"
      >
        {{ 'button.save' | transloco }}
      </htx-button>
    </div>

    <div class="form-sections">
      <htx-form-section
        [title]="t('sections.memberInfo')"
        [icon]="'person'"
        [formGroup]="form"
        [showErrorSummary]="true"
        [controlNames]="['title', 'firstName', 'lastName', 'email', 'position', 'phoneNumber']"
        [fieldLabels]="fieldLabels"
      >
          <htx-dropdown-field
            [ctrl]="form.controls.title"
            [label]="t('controls.title.label')"
            [options]="salutationOptions()"
            placeholder="Select title"
          >
          </htx-dropdown-field>
          <htx-text-field
            [ctrl]="form.controls.firstName"
            [label]="t('controls.firstName.label')"
          >
          </htx-text-field>
          <htx-text-field
            [ctrl]="form.controls.lastName"
            [label]="t('controls.lastName.label')"
          >
          </htx-text-field>
          <htx-text-field
            [ctrl]="form.controls.position"
            [label]="t('controls.position.label')"
          >
          </htx-text-field>
          <htx-text-field
            [ctrl]="form.controls.email"
            [label]="t('controls.email.label')"
            type="email"
          >
          </htx-text-field>
          <htx-text-field
            [ctrl]="form.controls.phoneNumber"
            [label]="t('controls.phoneNumber.label')"
            type="tel"
          >
          </htx-text-field>
      </htx-form-section>

      <htx-form-section
        [title]="t('sections.permissions')"
        [icon]="'shield'"
      >
        @if (isSelfEdit()) {
          <htx-alert variant="info" [message]="t('selfEditRolesHint')"></htx-alert>
        }
        <div class="roles-grid" [formGroup]="form">
          <div formGroupName="roles" class="roles-checkboxes">
            @for (role of assignableRoles; track role) {
              <htx-checkbox-field
                [ctrl]="form.get('roles')!.get(role)!"
                [label]="'organization.member.roles.labels.' + role.toLowerCase() | transloco"
              ></htx-checkbox-field>
            }
          </div>
        </div>
      </htx-form-section>

      <htx-form-section
        [title]="t('sections.status')"
        [icon]="'toggle_on'"
      >
        <htx-dropdown-field
          [ctrl]="form.controls.activityState"
          [label]="t('controls.activityState.label')"
          [options]="statusOptions()"
        >
        </htx-dropdown-field>
      </htx-form-section>

      @if (showRepChangeSection()) {
        <htx-form-section
          [title]="'representativeChange.create.sectionTitle' | transloco"
          [icon]="'swap_horiz'"
        >
          <htx-alert variant="info" [message]="'representativeChange.create.info' | transloco"></htx-alert>
          <htx-textarea-field
            [ctrl]="repChangeReasoningCtrl"
            [label]="'representativeChange.create.reasoning.label' | transloco"
          ></htx-textarea-field>
          <htx-file-upload-field
            [ctrl]="repChangeDocumentCtrl"
            [uploadText]="'representativeChange.create.document.uploadText' | transloco"
            [dragDropText]="'representativeChange.create.document.dragDropText' | transloco"
            [changeText]="'representativeChange.create.document.changeText' | transloco"
            [acceptedFileTypes]="'.pdf'"
          ></htx-file-upload-field>
          <htx-button
            variant="primary"
            icon="send"
            (click)="submitRepresentativeChange()"
            [disabled]="!repChangeDocumentCtrl.value || repChangeSubmitting()"
          >
            {{ 'representativeChange.create.submitButton' | transloco }}
          </htx-button>
        </htx-form-section>
      }
    </div>

    <div class="form-footer">
      <htx-button variant="primary" icon="save" (click)="save()" [disabled]="form.invalid">
        {{ 'button.save' | transloco }}
      </htx-button>
    </div>
  </div>
</div>
</app-protected-content>
